module.exports = __webpack_public_path__ + "static/media/copy.fa064ce0.png";